import { useAxios } from '@/hooks/useAxios';
import { getQueryKey } from '@/hooks/useQueryKeys';
import { Attribute, Webpage } from '@/types';
import { useQuery } from '@/utils/api';

type Response = {
  node: {
    relationships: {
      result: {
        hasvulnerabilities: {
          attachmentPath: string;
        }[];
      };
    }[];
    result: {
      webpages: Webpage[];
      attributes: Attribute[];
    };
  };
};

export type EvidenceFile = {
  attachmentPath: string;
  webpage: Webpage;
};

export function useEvidenceFiles(riskKey: string) {
  const axios = useAxios();

  return useQuery({
    queryKey: getQueryKey.getEvidenceFiles(riskKey),
    queryFn: async () => {
      const { data } = await axios({
        method: 'POST',
        url: '/my',
        params: {
          tree: true,
        },
        data: {
          node: {
            relationships: [
              {
                label: 'HAS_VULNERABILITY',
                target: {
                  labels: ['Risk'],
                  filters: [
                    {
                      field: 'key',
                      operator: '=',
                      value: riskKey,
                    },
                  ],
                },
              },
            ],
          },
        },
      });

      const evidenceFiles = data
        .map((entry: Response) => {
          const attachmentPath =
            entry?.node?.relationships?.[0]?.result?.hasvulnerabilities?.[0]
              ?.attachmentPath;
          const webpage = entry?.node?.result?.webpages?.[0];
          const attributes = entry?.node?.result?.attributes?.[0];

          if (!attachmentPath) return null;

          return {
            attachmentPath,
            webpage,
            attributes,
          };
        })
        .filter(Boolean);

      return evidenceFiles as EvidenceFile[];
    },
    defaultErrorMessage: 'Failed to fetch evidence files',
    enabled: !!riskKey,
  });
}
